export enum VossTimeLengthUnits {
    Day = 0,
    Month = 1,
    Year = 2,
}

export const VossTimeLengthUnitsText: Record<VossTimeLengthUnits, string> = {
    [VossTimeLengthUnits.Day]: 'vosstimelengthunits.day',
    [VossTimeLengthUnits.Month]: 'vosstimelengthunits.month',
    [VossTimeLengthUnits.Year]: 'vosstimelengthunits.year',
};

export const VossTimeLengthUnitsShortText: Record<VossTimeLengthUnits, string> = {
    [VossTimeLengthUnits.Day]: 'vossTimeLengthUnitsShort.day',
    [VossTimeLengthUnits.Month]: 'vossTimeLengthUnitsShort.month',
    [VossTimeLengthUnits.Year]: 'vossTimeLengthUnitsShort.year',
};

export const timeLengthUnits = Object.keys(VossTimeLengthUnitsText).map(Number) as VossTimeLengthUnits[];
